import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTrends(params) {
  return analytics.get('/trends/tests', { params });
}

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getAggregatedTestErrors(params) {
  return analytics.get('/trends/errors', { params });
}

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getAggregatedTestNames(params) {
  return analytics.get('/tests/names', { params });
}

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestHealth(params) {
  return analytics.get('/tests/health', { params });
}
